import React from 'react';
import { Page } from '../features/page';
import { ActionPanelPortalRef } from '../features/ActionPanel';
import { SidePanel } from '../features/SidePanel';
import { LazyBanner } from '../features/Banner';
import { HeaderRouter } from './HeaderRouter';
import { FooterRouter } from './FooterRouter';
import { MainRouter } from './MainRouter';

export function AppPage() {
  return (
    <Page
      actionpanel={<ActionPanelPortalRef />}
      header={<HeaderRouter />}
      footer={<FooterRouter />}
    >
      <LazyBanner />
      <MainRouter />
      <SidePanel />
    </Page>
  );
}
